module.exports = __webpack_public_path__ + "content/e6819b0ac994efe25ac94303fd9b8f8a.png";